<template>
  <div :class="classes">
    <pt-page-title :title="(isEdit?'编辑':'新建')+'促销活动'">
      <div slot="before-left" v-if="formValue.id==='newcomer'&&formValue.status==='ACTIVATED'" :class="$style['newcomer-tip-text']">
        该活动在编辑后需要等待审核，将暂时不可用，重新审核上架后方可生效
      </div>
    </pt-page-title>
    <pt-sub-title title="促销活动信息"></pt-sub-title>
    <template v-loading="pageLoading">
      <table :class="$style['promotion-form-message-table']" v-loading="loading">
        <pt-form-list-item label="活动名称:" :required="true">
          <wt-input data-vv-as="活动名称" name="name" v-validate="'required'" :disabled="isDisabled" :class="$style['coupon-table-name']"
                    v-model="formValue.promotionData.name"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="活动类型:" :required="true">
          <wt-selector :options="promotionTypeOption" v-model="formValue.promotionData.promotionType" :disabled="isDisabled"></wt-selector>
        </pt-form-list-item>
        <pt-form-list-item label="事业部归属:" :required="true" v-if="isCashBack">
          <wt-selector :options="businessDepartments" v-model="formValue.businessDepartmentId" :props="{label:'name',value:'id'}" :disabled="isDisabled">
          </wt-selector>
        </pt-form-list-item>
        <template v-if="formValue.promotionData.promotionType=='COUPONS_PACKAGE'">
          <pt-form-list-item label="发放数量:" :required="true">
            <div>
              <wt-input-number :min="0" v-validate="'required|numeric|min_value:1|is_not:0'" data-vv-as="发放数量" name="name" controls-position="right"
                               :class="$style['provide-number']" v-model="formValue.amount"></wt-input-number>份
            </div>
          </pt-form-list-item>
          <pt-form-list-item label="活动模板:" :required="true">
            <wt-input v-model="formValue.template" placeholder="new-user" :class="$style['coupon-table-name']" data-vv-as="活动模板" name="name"
                      v-validate="'required'"></wt-input>
          </pt-form-list-item>
        </template>
        <pt-form-list-item label="生效时间:" :required="true">
          <pt-time-slot :disabled="isDisabled" @change="validity_time" :endTime="promotionData.endTime" :startTime="promotionData.startTime" type="datetime"
                        :isClearStart="isClearStart" :isClearEnd="isClearEnd"></pt-time-slot>
          <wt-input style="display:none" v-model="formValue.promotionData.startTime" data-vv-as="促销活动开始时间" name="name" v-validate="'required'"></wt-input>
          <wt-input style="display:none" v-model="formValue.promotionData.endTime" data-vv-as="促销活动结束时间" name="name" v-validate="'required'"></wt-input>
        </pt-form-list-item>
        <template v-if="showFullReductionDiscount">
          <pt-form-list-item label="满减:" :required="true">
            <el-switch :value="formValue.fullReductionDiscount.openFullReduction" @change="openFullReductionChange()"></el-switch>
          </pt-form-list-item>
          <pt-form-list-item label="" v-if="formValue.fullReductionDiscount.openFullReduction">
            <div :class="$style['full-reduction-discount-content']">
              <div :class="$style['full-reduction-type']">
                满减形式： <wt-radio v-model="formValue.fullReductionDiscount.fullReductionType" :radios="fullReductionTypes" data-vv-as="满减形式" name="shippingModes"
                          v-validate="'required'"></wt-radio>
              </div>
              <template v-if="formValue.fullReductionDiscount.fullReductionType">
                <table>
                  <tr v-for="(item,index) in formValue.fullReductionDiscount.fullReductions" :key="index">
                    <td>
                      <div class="full-eductions">满<wt-input class="discount-condition-input" v-model="item.discountCondition_show"></wt-input>
                        {{fullReductionsText}}
                      </div>
                    </td>
                    <td>
                      <div class="full-eductions">
                        <wt-input class="discount-condition-input" v-model="item.discount_show"></wt-input>折
                      </div>
                    </td>
                    <td>
                      <el-button type="text" @click="deleteFullReductions(item,index)">删除</el-button>
                    </td>
                  </tr>
                </table>
                <div class="add-discount-condition">
                  <el-button type="text" @click="addFullReductions">+增加一条</el-button>
                </div>
              </template>
            </div>
          </pt-form-list-item>
        </template>
        <pt-form-list-item label="分享者：" v-if="is_CASH_BACK" required>
          <select-user-fitter ref="selectUser" fromPage="promotion-form" :isActive="isActive" :mallUserCriteria="mallUserCriteria"
                              @importLoading="importLoading" :selectedUserList="selectUserList" :selectedUserIdsList="selectedUserIdsList"
                              @userSubmit="userSubmit" :disableSelect="disableSelect">
          </select-user-fitter>
        </pt-form-list-item>
        <pt-form-list-item v-if="promotionData.promotionType === 'CPS_BIND'" label="奖励金额：">
          <wt-input :disabled="isActive" v-model="formValue.reword_money_show" placeholder="奖励金额" :class="$style['number-input-price']" data-vv-as="奖励金额"
                    name="name" type="number" v-validate="'decimal:2|min_value:0|is_not:0'">
            <el-button slot="append">¥</el-button>
          </wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="优惠劵：" v-if="isAddCoupons" :required="promotionData.promotionType !== 'CPS_BIND'">
          <el-button type="primary" plain @click="selectCoupon">添加优惠劵</el-button>
          <wt-input v-if="promotionData.promotionType !== 'CPS_BIND'" v-model="coupon_length" style="display:none" data-vv-as="优惠劵" name="name"
                    v-validate="'required'"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="适用商品:" :required="true" v-else-if="isShowSelectaGoods">
          <el-button type="primary" plain @click="selectGoods" :disabled="isDisabled">点击选择</el-button>
          <wt-input :value="goods_length" style="display:none" data-vv-as="适用商品" name="name" v-validate="'required'"></wt-input>
        </pt-form-list-item>
      </table>
      <template v-if="goods_list&&goods_list.length&&isShowSelectaGoods">
        <pt-sub-title title="已选商品"></pt-sub-title>
        <promotion-selected-goods :isActive="isActive" :value="goodsList" @selelctGoods="selelctGoods" :promotion-type="formValue.promotionData.promotionType"
                                  @deleteGoods="deleteGoods" :openFullReduction="formValue.fullReductionDiscount.openFullReduction"></promotion-selected-goods>
      </template>
      <template v-if="goods_list&&goods_list.length&&is_CASH_BACK">
        <pt-sub-title title="商品返券设置">
          <span slot="line" :class="$style['goods-coupon-set-text']">在选择商品后，请为其设置购买者及分享人可享受的商品优惠券；</span>
        </pt-sub-title>
        <div :class="$style['goods-coupon-buyer']">购买者返券：</div>
        <selected-goods-get-coupons :isActive="isActive" :value="goodsList" @selectCouponSubmit="customerType='buyer'" :customerType="'buyer'"
                                    @selelctGoods="selelctGoods"></selected-goods-get-coupons>
        <div :class="$style['goods-coupon-shower']">分享者者返券：</div>
        <selected-goods-get-coupons :isActive="isActive" :value="goodsList" @selectCouponSubmit="customerType='shower'" customerType="shower"
                                    @selelctGoods="selelctGoods"></selected-goods-get-coupons>
        <pt-sub-title title="脐血存储活动设置"> </pt-sub-title>
        <selected-goods-get-store :value="goodsList" @selelctGoods="selelctGoods"></selected-goods-get-store>
        <pt-sub-title title="抽奖活动设置"> </pt-sub-title>
        <selected-goods-get-draw :value="goodsList" @selelctGoods="selelctGoods"></selected-goods-get-draw>
      </template>
      <!-- <template  v-if="goods_list&&goods_list.length&&is_CASH_BACK">

          </template> -->
      <template v-if="showCouponsList">
        <pt-sub-title title="已选优惠劵"></pt-sub-title>
        <wt-table :list="coupon_list">
          <template>
            <el-table-column label="优惠劵:">
              <template slot-scope="scope">
                {{scope.row.couponData&&scope.row.couponData.name}}
              </template>
            </el-table-column>
            <el-table-column label="优惠劵内容">
              <template slot-scope="scope">
                <div>{{scope.row.discount}}</div>
                <div>满{{scope.row.thresholdOfAmount}}元可使用</div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="剩余库存（张）">
                        <template slot-scope="scope">
                            {{scope.row.surplusAmount}}
                        </template>
                    </el-table-column> -->
            <el-table-column label="赠券张数">
              <template slot-scope="scope">
                <wt-input v-model="scope.row.couponAmount" data-vv-as="赠券张数" type="number" v-validate="'gtezero'"></wt-input>
              </template>
            </el-table-column>
            <el-table-column label="删除">
              <template slot-scope="scope">
                <el-button type="text" @click="deleteCoupon(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </wt-table>
      </template>
    </template>
    <el-dialog :visible="is_dialog" :title="dialog_title" @close="closeDialog"
               :class="$style[is_select_coupon?'coupon-dialog':[(isSelectUser||isViewUser)?'user-dialog':'goods-dialog']]">
      <coupon-for-goods v-if="is_select_goods" @selectGoodsSubmit="selectGoodsSubmit" @close="closeDialog" :selected-goods="goods_list" :group-list="groupList">
      </coupon-for-goods>
      <coupon-list v-if="is_select_coupon" @selectCouponSubmit="selectCouponSubmit" @close="closeDialog" :selected-coupon="coupon_list"></coupon-list>
    </el-dialog>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import promotionSelectedGoods from './promotion-selected-goods'
import couponForGoods from '../../select-for-goods'
import couponList from '../coupon-list'
import { cashCount } from '@/utils/formUtils'
import { promotionType, specificationsData, fullReductionTypes } from '../promotion-option'
import selectedGoodsGetCoupons from './selected-goods-get-coupons'
import selectedGoodsGetStore from './selected-goods-get-store'
import selectedGoodsGetDraw from './selected-goods-get-draw'
import selectUserFitter from 'cps/base/select-user-fitter/index'
// 组件class前缀
const prefixCls = 'pt-promotion-form'
export default {
  name: 'pt-promotion-form',
  mixins: [formMixins],
  components: {
    couponForGoods,
    couponList,
    promotionSelectedGoods,
    selectedGoodsGetCoupons,
    selectUserFitter,
    selectedGoodsGetStore,
    selectedGoodsGetDraw
  },
  computed: {
    // 是否添加优惠券
    isAddCoupons () {
      return (this.promotionData.promotionType === 'COUPONS_PACKAGE' || this.promotionData.promotionType === 'CPS_BIND')
    },
    // 促销活动是否是通用促销活动
    isCashBack () {
      return this.promotionData.promotionType === 'CASH_BACK'
    },
    // 是否显示优惠券
    showCouponsList () {
      return (this.promotionData.promotionType === 'COUPONS_PACKAGE' || this.promotionData.promotionType === 'CPS_BIND') && this.coupon_list && this.coupon_list.length > 0
    },
    pageLoading () {
      return this.loading || this.customerLoading
    },
    classes () {
      return `${prefixCls}`
    },
    promotionData () {
      return this.formValue.promotionData || {}
    },
    is_dialog: {
      get: function () {
        return this.is_select_goods || this.is_select_coupon || this.isSelectUser || this.isViewUser
      },
      set: function (val) {
        this.is_select_goods = val
        this.is_select_coupon = val
        this.isSelectUser = val
        this.isViewUser = val
      }
    },
    goods_length () {
      return this.goods_list.length > 0 ? this.goods_list.length : null
    },
    coupon_length () {
      return this.coupon_list.length > 0 ? this.coupon_list.length : null
    },
    // 是否是优惠/返券通用促销活动
    is_CASH_BACK () {
      return this.formValue.promotionData.promotionType === 'CASH_BACK'
    },
    // 是否显示商品部分
    isShowSelectaGoods () {
      return this.is_CASH_BACK || this.formValue.promotionData.promotionType === 'SNAP_UP' || this.formValue.promotionData.promotionType === 'TIME_LIMIT_DISCOUNT'
    },
    // 单项是否可编辑（如果是已激活的促销活动，只有分享者可编辑）
    isDisabled () {
      return this.isActive
    },
    // 满减显示按件还是钱
    fullReductionsText () {
      return this.formValue.fullReductionDiscount.fullReductionType === 'MONEY' ? '元' : '件（销售单位）'
    },
    showFullReductionDiscount () {
      return this.formValue.promotionData.promotionType === 'TIME_LIMIT_DISCOUNT'
    }
  },
  props: {
    form: {
      type: Object,
      default: function () {
        return {
          promotionData: {},
          rewardContent: {},
          userListId: [],
          fullReductionDiscount: {}
        }
      }
    },
    groupList: {
      type: Array,
      default: function () {
        return []
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    },
    businessDepartments: Array
  },
  data () {
    return {
      formValue: this.form,
      is_select_goods: false,
      dialog_title: '',
      goods_list: [],
      promotionTypeOption: promotionType,
      is_select_coupon: false,
      coupon_list: [],
      goodsList: [],
      discountGoodsData: [],
      startTime: '',
      endTime: '',
      isClearEnd: false,
      isClearStart: false,
      isSelectUser: false,
      isViewUser: false,
      firstUserName: null,
      selectUserList: [],
      mallUserQuery: [],
      customerType: null,
      disableSelect: false,
      selectedUserIdsList: [],
      customerLoading: false,
      fullReductionTypes: fullReductionTypes,
      fullReductionDiscount: {
        fullReductions: [{}]
      }
    }
  },
  watch: {
    'formValue.fullReductionDiscount': {
      handler: function (val) {

      },
      deep: true
    },
    startTime: {
      handler: function (val) {
        if (this.endTime && this.endTime < val) {
          this.$message.error('请选择早于结束时间的开始时间')
          this.isClearStart = true
          this.$set(this.form.promotionData, 'startTime', null)
        }
      }
    },
    endTime: {
      handler: function (val) {
        if (this.startTime && this.startTime > val) {
          this.$message.error('请选择晚于开始时间的结束时间')
          this.isClearEnd = true
          this.$set(this.form.promotionData, 'endTime', null)
        }
      }
    },
    form: {
      handler: function (val) {
        this.formValue = { fullReductionDiscount: { fullReductions: [{}] }, ...JSON.parse(JSON.stringify(val)) }
        console.log('this.formValue', this.formValue)
        if ((val.promotionData.promotionType === 'TIME_LIMIT_DISCOUNT' || val.promotionData.promotionType === 'SNAP_UP' ||
        val.promotionData.promotionType === 'CASH_BACK') && val.detailData) {
          this.goods_list = (this.goods_list && this.goods_list.length > 0) ? this.goods_list : val.detailData
        } else {
          if (val.couponsPackageData) {
            this.coupon_list = val.couponsPackageData
          }
          if (val.rewardContent) {
            this.coupon_list = val.rewardContent.coupons
          }
        }
        this.mallUserCriteria = val.mallUserCriteria && JSON.parse(JSON.stringify(val.mallUserCriteria))
        this.selectUserList = val.userInfo && JSON.parse(JSON.stringify(val.userInfo))
        this.selectedUserIdsList = val.userIds && JSON.parse(JSON.stringify(val.userIds))
        // if(val.mallUserQueryData){

        // }
        // this.mallUserQuery = val.mallUserQueryData && JSON.parse(JSON.stringify(val.mallUserQueryData))
        // if (val.userInfo) {
        //   this.userData(val.userInfo)
        // }
        // this.goods_list = val.detailData
      },
      deep: true
    },
    goods_list: {
      handler: function (val, old) {
        this.goodsList = specificationsData(val, old)
      }
    //   deep: true
    },
    goodsList: {
      handler: function (val) {
        if (val && val.length > 0) {
          this.formValue.detailData = []
          let submitGoodsList = []
          submitGoodsList = JSON.parse(JSON.stringify(this.goods_list))
          submitGoodsList.forEach(item => {
            item.specifications = []
            if (item.goodsDTO && item.goodsDTO.goodsData && item.goodsDTO.goodsData.specifications && item.goodsDTO.goodsData.specifications[0] && item.goodsDTO.goodsData.specifications[0].items) {
            //   item.goodsDTO.goodsData.specifications[0].items = []
              val.forEach(etem => {
                //   if (isEmptyObject(etem.specifications) || !etem.specifications.itemId || item.goodsDTO.id === etem.specifications.goodsId) {
                if (item.goodsDTO.id === etem.specifications.goodsId) {
                  etem.specifications.specificationId = etem.specifications.itemId || null
                  etem = this.specificationSet(etem)
                  item.specifications.push(etem.specifications)
                }
              })
            } else {
              val.forEach(atem => {
                if (item.goodsDTO.id === atem.goodsDTO.id) {
                  atem = this.specificationSet(atem)
                  item.specifications.push(atem.specifications)
                }
              })
            }
          })
          if (this.formValue.promotionData && this.formValue.promotionData.promotionType === 'SNAP_UP') {
            submitGoodsList.forEach(item => {
              this.formValue.detailData.push({
                goodsId: item.goodsDTO.goodsData.goodsId,
                snapUpPrice: cashCount(item.snapUp_price),
                amount: item.amount,
                discountGoodsData: item.specifications
              })
            })
          } else if (this.formValue.promotionData && this.formValue.promotionData.promotionType === 'TIME_LIMIT_DISCOUNT') {
            submitGoodsList.forEach(item => {
              this.formValue.detailData.push({
                goodsId: item.goodsDTO.goodsData.goodsId,
                discount: cashCount(item.discount_show),
                discountGoodsData: item.specifications
              })
            })
          } else if (this.formValue.promotionData && this.formValue.promotionData.promotionType === 'CASH_BACK') {
            submitGoodsList.forEach(item => {
              console.log('item.specifications', item.specifications)
              this.formValue.detailData.push({
                goodsId: item.goodsDTO.goodsData.goodsId,
                discountGoodsData: item.specifications
              })
            })
          }
        }
      },
      deep: true
    },
    coupon_list: {
      handler: function (val, old) {
        if (val && val.length > 0) {
          if (this.promotionData.promotionType === 'CPS_BIND') {
            this.formValue.rewardContent = this.formValue.rewardContent || {}
            this.formValue.rewardContent.coupons = []
            val.forEach(item => {
              this.formValue.rewardContent.coupons.push({
                id: item.id,
                couponAmount: Number(item.couponAmount)
              })
            })
          } else {
            this.formValue.couponsPackageData = []
            val.forEach(item => {
              this.formValue.couponsPackageData.push({
                id: item.id,
                couponAmount: Number(item.couponAmount)
              })
            })
          }
        }
      },
      deep: true
    },
    'formValue.reword_money_show': {
      handler: function (val) {
        this.formValue.rewardContent = this.formValue.rewardContent || {}
        this.formValue.rewardContent.money = cashCount(val)
      }
    }
  },
  methods: {
    openFullReductionChange () {
      this.formValue.fullReductionDiscount.openFullReduction = !this.formValue.fullReductionDiscount.openFullReduction
    },
    deleteFullReductions (row, index) {
      this.formValue.fullReductionDiscount.fullReductions.splice(index, 1)
    },
    addFullReductions () {
      this.formValue.fullReductionDiscount.fullReductions.push({})
    },
    importLoading (val) {
      this.customerLoading = val
    },
    userSubmit (val) {
      // if (val && val.userListId) {
      // if (this.formValue.userIds) {
      //   this.$delete(this.formValue, 'userIds')
      // }
      // if (this.formValue.mallUserQuery) {
      //   this.$delete(this.formValue, 'mallUserQuery')
      // }
      //   this.disableSelect = true
      //   let mallUserCriteria = {
      //     mallUserCriteria: {
      //       whiteList: [
      //         {
      //           userListId: val.userListId
      //         }
      //       ]
      //     }
      //   }
      //   this.formValue = { ...this.formValue, ...mallUserCriteria, ...val }
      //   this.$delete(this.formValue, 'userListId')
      // } else {
      //   this.formValue = { ...this.formValue, ...val }
      // }
      this.formValue = { ...this.formValue, ...val }
    },
    selelctGoods (val) {
      this.$set(this, 'goodsList', val)
    },
    getGoodsPrice (val) {
      let price
      if (val.specifications) {
        price = val.specifications.price
      } else {
        price = val.goodsDTO.goodsData.finalPrice
      }
      return price
    },
    specificationSet (etem) {
      if (this.formValue.promotionData.promotionType === 'TIME_LIMIT_DISCOUNT') {
        if (etem.discount_show) etem.specifications.discount = (etem.discount_show && cashCount(etem.discount_show)) || null
        etem.specifications.useFullReduction = etem.useFullReduction || null
      }
      if (this.formValue.promotionData.promotionType === 'SNAP_UP') {
        etem.specifications.amount = etem.amount
        etem.specifications.snapUpPrice = (etem.snapUp_price && cashCount(etem.snapUp_price)) || null
      }
      if (this.formValue.promotionData.promotionType === 'CASH_BACK') {
        etem.specifications.discount = (etem.discount_show && cashCount(etem.discount_show)) || null
        etem.specifications.buyerCashBack = (etem.buyer_cashBack && cashCount(etem.buyer_cashBack)) || null
        etem.specifications.sharerCashBack = (etem.sharer_cashBack && cashCount(etem.sharer_cashBack)) || null
        etem.specifications.buyerCouponsBack = etem.buyerCouponsBack
        etem.specifications.sharerCouponsBack = etem.sharerCouponsBack
        etem.specifications.bringNewReward = etem.bringNewReward
        etem.specifications.buyerTicketsReward = etem.buyerTicketsReward
        etem.specifications.sharerTicketsReward = etem.sharerTicketsReward
        etem.specifications.actId = etem.actId
      }
      return etem
    },
    selectCoupon () {
      this.is_select_coupon = true
      this.dialog_title = '选择优惠劵'
    },
    selectCouponSubmit (val) {
      this.is_select_coupon = false
      this.coupon_list = val
    },
    deleteCoupon (val) {
      this.coupon_list.forEach((item, index) => {
        if (item.id === val.id) {
          this.coupon_list.splice(index, 1)
        }
      })
    },
    validity_time (val) {
      this.endTime = val.endTime
      this.startTime = val.startTime
      this.$set(this.formValue.promotionData, 'startTime', val.startTime)
      this.$set(this.formValue.promotionData, 'endTime', val.endTime)
      //   this.formValue.promotionData.startTime = val.startTime
      //   this.formValue.promotionData.endTime = val.endTime
    },
    deleteGoods (val, index) {
      this.goodsList.splice(index, 1)
      this.goods_list.forEach((item, index) => {
        if (item.goodsDTO.id === val.goodsDTO.id) {
          if (item.discountGoodsData && item.discountGoodsData.length > 0) {
            if (val.specifications.itemId && item.discountGoodsData.length > 1) {
              item.discountGoodsData.forEach((etem, i) => {
                if (etem.specificationId === val.specifications.itemId) {
                // this.goods_list.splice(index, 1)
                  item.discountGoodsData.splice(i, 1)
                }
              })
            } else {
              this.goods_list.splice(index, 1)
            }
          } else {
            let specificationsItems = (item.goodsDTO && item.goodsDTO.goodsData && item.goodsDTO.goodsData.specifications && item.goodsDTO.goodsData.specifications[0] && item.goodsDTO.goodsData.specifications[0].items) || null
            if (specificationsItems && specificationsItems.length > 1) {
              specificationsItems.forEach((ttem, e) => {
                if (ttem.itemId === val.specifications.itemId) {
                  specificationsItems.splice(e, 1)
                }
              })
            } else {
              this.goods_list.splice(index, 1)
            }
          }
        }
      })
    },
    selectGoods () {
      this.is_select_goods = true
      this.dialog_title = '选择商品'
    },
    selectGoodsSubmit (val) {
      this.is_select_goods = false
      this.$set(this, 'goods_list', JSON.parse(JSON.stringify(val)))
      // this.goods_list = JSON.parse(JSON.stringify(val))
    },
    closeDialog () {
      this.is_dialog = false
    }
  }
}
</script>

<style module lang="less">
@import "~less/var.less";
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.full-reduction-type{
	display: flex
}
.full-reduction-discount-content{
	:global{
		table{
			td{
				padding: 10px;
			}
		}
		.add-discount-condition{
			width: 100%;
			display: flex;
			// justify-content: flex-end;
		}
		.full-eductions{
			display: flex;
			align-items: center;
			.discount-condition-input{
				margin: 0 10px;
			}
		}
	}
}
.commonly-screen-user{
  :global
  .el-radio-group{
    line-height: 40px;
    label{
      line-height: 40px
    }
  }
}
.coupon-table-name{
    max-width: 300px;
}
.sharer-text{
    color: @tipTextColor;
    margin-left: 20px;
    font-size: 13px;
}
.promotion-form-message-table{
    padding: 0 20px;
}
.number-input-price{
    max-width: 200px;
    min-width: 120PX;
    margin-right: 10px;
    :global
    .el-button{
        padding: 10px
    }
}
.number-input-discount{
     max-width: 150px;
    min-width: 100PX;
    margin-right: 10px;
     :global
    .el-button{
        padding: 10px
    }
    :global
    input[type="number"]{
      padding:8px!important
    }
}
.seckilling-setting{
    display: flex
}
.provide-number{
    display: inline-block;
    margin-right: 10px;
}
.coupon-dialog{
    :global
    .el-dialog{
        width: 70%;
        max-width: 900px;
    .el-dialog__body{
     padding: 0 20px 30px;
    }
    }

}
.user-dialog{
  top: 10px;
    :global
    .el-dialog{
      top: 50px;
        width: 70%;
        min-width:1100PX;
        max-width:1500Px;
    }
}
.goods-dialog{
   :global
    .el-dialog{
        width: 70%;
        max-width: 1000px;
    .el-dialog__body{
     padding: 0 20px 30px;
    }
    }
}
.newcomer-tip-text{
    color: red
}
.goods-coupon-set-text{
    font-size: 13px;
    color: @tipTextColor;
    margin-left: 20px;
}
.goods-coupon-buyer{
    padding: 0 20px;
    font-weight: 600
}
.goods-coupon-shower{
    padding: 20px 20px 0;
    font-weight: 600
}
</style>
